// extracted by mini-css-extract-plugin
export default {"row":"Captcha_row__w+7sL","captcha":"Captcha_captcha__345Ho","button":"Captcha_button__Ag7nM"};